export default __webpack_public_path__ + "static/media/start-over-icon.cb8bb545.svg";